/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @eventmobi/no-direct-capacitor-import */
// skipcq: JS-C1003
import * as App from '@capacitor/app';
// skipcq: JS-C1003
import * as AppLauncher from '@capacitor/app-launcher';
// skipcq: JS-C1003
import * as BarcodeScanner from '@capacitor/barcode-scanner';
// skipcq: JS-C1003
import * as Browser from '@capacitor/browser';
// skipcq: JS-C1003
import * as Camera from '@capacitor/camera';
// skipcq: JS-C1003
import * as Core from '@capacitor/core';
// skipcq: JS-C1003
import * as Device from '@capacitor/device';
// skipcq: JS-C1003
import * as Keyboard from '@capacitor/keyboard';
// skipcq: JS-C1003
import * as Network from '@capacitor/network';
// skipcq: JS-C1003
import * as Preferences from '@capacitor/preferences';
// skipcq: JS-C1003
import * as SplashScreen from '@capacitor/splash-screen';

/**
 * Don't forget to mention any newly added plugin into `allowedPlugins` array in ./capacitor.config.json
 */
export default {
  // Official plugins
  App,
  AppLauncher,
  BarcodeScanner,
  Browser,
  Camera,
  Core,
  Device,
  Keyboard,
  Network,
  Preferences,
  SplashScreen,
};
